import { Injectable, Injector } from '@angular/core';
import * as Sentry from '@sentry/browser';
import {
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorsService } from './errors.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor (
    private injector: Injector,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const errorsService = this.injector.get(ErrorsService);

        if (Sentry.getCurrentHub().getClient()) {
          // Send error to Sentry
          Sentry.withScope(scope => {
            scope.setExtra('backend_error', error.error);
            errorsService.log(new Error(error.message));
          });
        } else {
          console.error('Please initialize Sentry by calling Sentry.init()');
        }

        return throwError(error);
      })
    );
  }
}
